import React from 'react';
import { PriceDisplay } from './PriceDisplay';
export function BonusSection() {
  return <div className="max-w-3xl mx-auto px-5 md:px-6 py-10" data-id="element-15">
      <hr className="border-t-2 border-dashed border-border-light mb-10" data-id="element-16" />

      <h2 className="font-serif text-2xl md:text-3xl font-bold text-dark text-center mb-4" data-id="element-17">
        Reclama Estos 4 Bonos Exclusivos Si Ordenas HOY
      </h2>
      <p className="text-center font-serif text-lg text-body-text mb-8" data-id="element-18">
        Si entras hoy, te daré{' '}
        <strong data-id="element-19">4 bonos especiales por tiempo limitado</strong> que te ayudarán
        a estimular a tu hijo/a aún más rápido...
      </p>

      {/* Bonus 1 */}
      <div className="bg-bonus-bg border-2 border-dashed border-[#90CAF9] rounded-xl py-7 px-6 my-6" data-id="element-20">
        <p className="font-sans text-sm uppercase tracking-[2px] text-[#1565C0] font-bold" data-id="element-21">
          Bono #1
        </p>
        <h3 className="font-sans text-xl md:text-2xl font-extrabold text-[#0D47A1] mt-1 mb-3" data-id="element-22">
          🧩 10 Juegos Montessori
        </h3>
        <p className="font-serif text-base text-body-text mb-3 leading-relaxed" data-id="element-23">
          El primer bono es una guía con{' '}
          <strong data-id="element-24">10 juegos inspirados en la filosofía Montessori</strong> que
          puedes hacer en casa con materiales simples. Juegos diseñados para
          fomentar la autonomía, la concentración y la coordinación de tu
          pequeño/a.
        </p>
        <p className="font-serif text-base text-body-text mb-3 leading-relaxed" data-id="element-25">
          Una sesión individual con un guía Montessori te costaría entre 40 € y
          80 € — aquí lo tienes incluido.
        </p>
        <p className="font-sans font-bold text-lg text-green-dark mt-3" data-id="element-26">
          Valor Regular: <PriceDisplay amount={15} data-id="element-27" /> — ¡Tuyo GRATIS!
        </p>
      </div>

      {/* Bonus 2 */}
      <div className="bg-bonus-bg border-2 border-dashed border-[#90CAF9] rounded-xl py-7 px-6 my-6" data-id="element-28">
        <p className="font-sans text-sm uppercase tracking-[2px] text-[#1565C0] font-bold" data-id="element-29">
          Bono #2
        </p>
        <h3 className="font-sans text-xl md:text-2xl font-extrabold text-[#0D47A1] mt-1 mb-3" data-id="element-30">
          🎨 Tarjetas de Alto Contraste Imprimibles
        </h3>
        <p className="font-serif text-base text-body-text mb-3 leading-relaxed" data-id="element-31">
          Recibes un set completo de <strong data-id="element-32">tarjetas de alto contraste</strong>{' '}
          listas para imprimir, diseñadas específicamente para estimular la
          visión de los recién nacidos y bebés pequeños.
        </p>
        <p className="font-serif text-base text-body-text mb-3 leading-relaxed" data-id="element-33">
          Estas tarjetas se venden por separado en tiendas de puericultura por
          10-20 €. Aquí las obtienes gratis y las puedes imprimir tantas veces
          como quieras.
        </p>
        <p className="font-sans font-bold text-lg text-green-dark mt-3" data-id="element-34">
          Valor Regular: <PriceDisplay amount={10} data-id="element-35" /> — ¡Tuyo GRATIS!
        </p>
      </div>

      {/* Bonus 3 */}
      <div className="bg-bonus-bg border-2 border-dashed border-[#90CAF9] rounded-xl py-7 px-6 my-6" data-id="element-36">
        <p className="font-sans text-sm uppercase tracking-[2px] text-[#1565C0] font-bold" data-id="element-37">
          Bono #3
        </p>
        <h3 className="font-sans text-xl md:text-2xl font-extrabold text-[#0D47A1] mt-1 mb-3" data-id="element-38">
          🥑 Alimentación BLW Segura
        </h3>
        <p className="font-serif text-base text-body-text mb-3 leading-relaxed" data-id="element-39">
          ¿Te preocupa la introducción de alimentos sólidos? Ahora puedes
          hacerlo con confianza.
        </p>
        <p className="font-serif text-base text-body-text mb-3 leading-relaxed" data-id="element-40">
          Con la guía <strong data-id="element-41">"Alimentación BLW Segura"</strong>, aprenderás los
          principios fundamentales del Baby Led Weaning: qué alimentos ofrecer
          según la edad, cómo cortarlos de forma segura, señales de que tu bebé
          está listo, y cómo evitar los errores más comunes.
        </p>
        <p className="font-sans font-bold text-lg text-green-dark mt-3" data-id="element-42">
          Valor Regular: <PriceDisplay amount={12} data-id="element-43" /> — ¡Tuyo GRATIS!
        </p>
      </div>

      <p className="text-center font-serif text-lg italic text-gray-600 my-6" data-id="element-44">
        Y para rematar, voy a hacer algo que no tenía planeado en absoluto...
      </p>

      {/* Bonus 4 */}
      <div className="bg-bonus-bg border-2 border-dashed border-[#90CAF9] rounded-xl py-7 px-6 my-6" data-id="element-45">
        <p className="font-sans text-sm uppercase tracking-[2px] text-[#1565C0] font-bold" data-id="element-46">
          Bono #4
        </p>
        <h3 className="font-sans text-xl md:text-2xl font-extrabold text-[#0D47A1] mt-1 mb-3" data-id="element-47">
          😤 10 Claves Para Gestionar Rabietas
        </h3>
        <p className="font-serif text-base text-body-text mb-3 leading-relaxed" data-id="element-48">
          Como si lo anterior no fuera suficiente, también te llevas la guía{' '}
          <strong data-id="element-49">"10 Claves Para Gestionar Rabietas"</strong>.
        </p>
        <p className="font-serif text-base text-body-text mb-3 leading-relaxed" data-id="element-50">
          Contiene estrategias probadas para manejar los berrinches con calma,
          entender qué los causa y cómo responder sin perder los nervios. Pensé
          en vender este bono por separado, pero para endulzar esta oferta, te
          lo incluyo.
        </p>
        <p className="font-serif text-base text-body-text mb-3 leading-relaxed" data-id="element-51">
          Piensa en esto como el manual de supervivencia emocional que todo
          padre necesita. Sin teoría aburrida. Son{' '}
          <strong data-id="element-52">10 claves prácticas y directas</strong> que puedes aplicar
          desde hoy mismo.
        </p>
        <p className="font-sans font-bold text-lg text-green-dark mt-3" data-id="element-53">
          Valor Regular: <PriceDisplay amount={12} data-id="element-54" /> — ¡Tuyo GRATIS!
        </p>
      </div>
    </div>;
}